import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'

import Spinning from 'grommet/components/icons/Spinning'

import RootPath from './components/RootPath'
import LayoutRoute from './components/LayoutRoute'

import '../node_modules/grommet/grommet-hpe.min.css'
import './styles/Fonts.css'

import './styles/App.css'

const history = createBrowserHistory()

class App extends Component {
  render () {
    if (this.props.loading) {
      return (
        <div className='AppLoading'>
          <Spinning size='xlarge' />
          <span>Loading...</span>
        </div>
      )
    }

    return (
      <Router history={history}>
        <div className='App'>
          <Route exact path='/' component={RootPath} />

          <LayoutRoute path='/menu/:id' dataType='menu' />
          <LayoutRoute path='/page/:id' dataType='page' />
          <LayoutRoute path='/slideshow/:id' dataType='slideshow' />
          <LayoutRoute path='/interactiveelement/:id' dataType='interactiveelement' />
          <LayoutRoute path='/contentdisplay/:id' dataType='contentdisplay' />
        </div>
      </Router>
    )
  }
}

App.propTypes = {
  loading: PropTypes.bool
}

const mapStateToProps = (state, ownProps) => {
  const {
    loading
  } = state.app

  return {
    loading
  }
}

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js